import AgentIndex from '../components/agents/AgentIndex.vue';
import AgentEdit from '../components/agents/AgentEdit.vue';

export default [
  {
    path: '/agents',
    name: 'AgentIndex',
    component: AgentIndex,
    meta: {
      requiresAuth: true,
      permissions: {
        Users: ["*"]
      }
    }
  },
  {
    path: '/agents/:agent_id',
    name: 'AgentEdit',
    component: AgentEdit,
    meta: {
      requiresAuth: true,
      permissions: {
        Users: ['Users', "Update User Password"]
      }
    },
  }
]



// WEBPACK FOOTER //
// ./src/router/AgentRoutes.js